/**
 * Canonical DataGrid field names for workflow list filtering. Both the
 * client's filter chips and the server's filter-model zod schemas derive
 * from this map, so the two sides of the contract cannot drift apart.
 */
export const WORKFLOW_FILTER_FIELDS = {
  board: 'board',
  column: 'column',
  columnCategory: 'column-category',
  labels: 'labels',
  name: 'name',
  owner: 'owner',
  permissions: 'permissions',
  priority: 'priority',
  state: 'state',
  workflowType: 'workflowType',
} as const;

export type WorkflowFilterFieldName =
  (typeof WORKFLOW_FILTER_FIELDS)[keyof typeof WORKFLOW_FILTER_FIELDS];

/** Workflow date fields accepted by the shared list and Insights filter model. */
export const WORKFLOW_DATE_FILTER_FIELDS = {
  completedAt: 'completedAt',
  createdAt: 'createdAt',
  publishedAt: 'publishedAt',
  signedAt: 'signedAt',
  startedAt: 'startedAt',
  updatedAt: 'updatedAt',
} as const;

export type WorkflowDateFilterFieldName =
  (typeof WORKFLOW_DATE_FILTER_FIELDS)[keyof typeof WORKFLOW_DATE_FILTER_FIELDS];
